import type { Notification } from "@circle-react/types/Notification";
import { Typography } from "@circleco/compass/components/Typography";

import { Typography as UiKitTypography } from "@/react/components/SettingsApp/CompassCompat/Typography";
import { useCircleV4 } from "@/react/hooks/useCircleV4";

export interface SecondActorNameProps {
  notification: Notification;
}

export const SecondActorName = ({ notification }: SecondActorNameProps) => {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    return (
      <Typography variant="label-sm">
        {notification.second_actor_name}
      </Typography>
    );
  }
  return (
    <UiKitTypography.BodySm as="span" weight="font-semibold">
      {notification.second_actor_name}
    </UiKitTypography.BodySm>
  );
};
